import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBlueEllipse = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 17 17",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("circle", {
		cx: 8,
		cy: 8,
		r: 8,
		fill: "#004FD6"
	})
});
export default SvgBlueEllipse;
